import withTranslation from '@helpers/i18n'
import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
  text-align: center;
  min-height: 200px;
`

const IconCircle = styled.div`
  width: 92px;
  height: 92px;
  border-radius: 50%;
  background-color: #fee9e7;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  flex-shrink: 0;
`

const Title = styled.p`
  font-size: 18px;
  font-weight: 700;
  color: #2d3a62;
  margin: 0 0 8px;
`

const ErrorFallback = ({ t }) => {
  return (
    <Wrapper>
      <IconCircle>
        <i className="material-icons" style={{ color: '#E74C3C', fontSize: '40px' }}>
          bug_report
        </i>
      </IconCircle>
      <Title>{t('.error_ajax')}</Title>
      <span className="text-light max-w-sm mb-20">{t('.unexpected_error')}</span>
      <button className="button primary" onClick={() => window.location.reload()}>
        <i className="material-icons mie-10">refresh</i>
        <span>{t('.reload_page')}</span>
      </button>
    </Wrapper>
  )
}

export default withTranslation('js.shared')(ErrorFallback)
